import type { TopicResponseMediaLinksItemProjectInfoEngagementAllOf } from './topicResponseMediaLinksItemProjectInfoEngagementAllOf';
import type { TopicResponseMediaLinksItemProjectInfoEngagementAllOfTwo } from './topicResponseMediaLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type TopicResponseMediaLinksItemProjectInfoEngagement = TopicResponseMediaLinksItemProjectInfoEngagementAllOf & TopicResponseMediaLinksItemProjectInfoEngagementAllOfTwo;
